import { render } from "./ComponentViewerItem.vue?vue&type=template&id=4c415505&scoped=true"
import script from "./ComponentViewerItem.vue?vue&type=script&lang=js"
export * from "./ComponentViewerItem.vue?vue&type=script&lang=js"

import "./ComponentViewerItem.vue?vue&type=style&index=0&id=4c415505&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c415505"]])

export default __exports__